import React, { useState, useEffect, useRef } from "react";
import Navigation from "../../../common/Navigation";
import growthicon from "../../../assets/img/GG210.png";
import Button from "@material-ui/core/Button";
import axios from "axios";
import * as yup from "yup";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";
import { API_AUTH } from "../../../utils/config";
import { Input } from "reactstrap";
//  sign up screen component
const SignUpScreen = (props) => {
  let history = useHistory();


  const [err, seterr] = useState("");
  const [hidden, setHidden] = useState(false);
  const textInput = useRef(null);
  const signupValidationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Please enter valid email")
      .required("Email address is required"),
  });

  useEffect(() => {
    checkingCurrentUser();
    textInput.current.focus();
  });
  // checking current candidate function
  const checkingCurrentUser = () => {
    axios
      .get(`${API_AUTH}/v1/api/auth/isLoggedIn`, { withCredentials: true })
      .then((response) => {
        if (response.data) {
          history.push({
            pathname: "/dashboard",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // onSubmit function for navigating to 
  const onSubmit = async (email) => {
    let body = {
      email,
      ipAddress: "150.82.224.211",
      browser: "",
      OS: "",
      isTablet: false,
      isPhone: false,
      isBot: false,
      location: "",
      isSuspicious: false,
    };
    console.log(body);
    await axios
      .post(`${API_AUTH}/v1/api/auth/verify/signup`, body, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        if (response.data.ok && hidden) {
          history.push({
            pathname: "/signup_password",
            state: email,
          });
        } else if (!response.data.ok) {
          seterr("Email already exists");
        } else if(!hidden) {
          seterr("Please accept terms and conditions");
        }
      })
      .catch((err) => {
        console.log("charity", err);
      });
  };

  // const onkeySubmit= async (email)=>{
  //   console.log(email,"enter key working")
  //    onSubmit(email)
  // }

  const toggleShow = () => {
    setHidden(!hidden);
    seterr("");
  };

  return (
    <div>
      <Navigation show="true" />
      <div className="sign-container">
        <Formik
          validationSchema={signupValidationSchema}
          initialValues={{ email: "" }}
          onSubmit={(values) => onSubmit(values.email)}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
            isValid,
          }) => (
            <>
              <div className="child-signcontainer">
                <div className="child-firstcontainer">
                  <img
                    style={{ marginRight: "20px", marginTop: "50px" }}
                    src={growthicon}
                    height="60"
                    width="170"
                    alt="PION global"
                    id="logo"
                  ></img>
                </div>

                <div className="child-secondcontainer">
                  <span style={{ fontWeight: 500, fontSize: "20px" }}>
                    Create Account
                  </span>

                  <div className="sign-form">
                    <input
                      type="email"
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      name="email"
                      ref={textInput}
                      // onKeyPress={(values)=>onkeySubmit(values.email)}
                      placeholder="someone@example.com"
                      onChange={(email) => {
                        handleChange(email);
                        seterr("");
                     
                      }}
                      value={values.email}
                      autoComplete="off"
                      required
                    ></input>
                    {errors.email && touched.email && (
                      <span style={{ fontSize: 15, color: "red" }}>
                        {errors.email}
                      </span>
                    )}

                    {err && (
                      <span style={{ fontSize: 15, color: "red" }}>{err}</span>
                    )}

                    {/* <span  style={{ fontSize: 15, color: 'red' }}>{validemail}</span> */}
                  </div>
                  <div
                    style={{
                      display: "flex",

                      marginTop: "-10px",
                    }}
                  >
                    <Input
                      style={{ width: "30px" }}
                      type="checkbox"
                      onClick={toggleShow}
                    />
                    <span
                      style={{
                        fontSize: "0.87rem",
                        marginLeft: "8px",
                        width: "100%",
                      }}
                    >
                      I accept the terms and provide approval for processing my
                      profile, professional experiences, personal details by
                      Growth Gamut Recruiters, their Customers, Partners and
                      Consultants.
                    </span>
                  </div>
                </div>
                <div className="log-button">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handleSubmit();
                    }}
                    style={{ background: "#005500" }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SignUpScreen;
